import { IconButton } from '@mui/material'
import React from 'react'
import { RouteConstants } from '../../navigation/navigation-types'
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded'
import { Link } from 'react-router-dom'

interface TableButtonOpenProps {
    route: RouteConstants | string
    id?: string
    hash?: string | number
}
const TableButtonOpen: React.FC<TableButtonOpenProps> = ({ route, id, hash }: TableButtonOpenProps) => {
    return (
        <Link to={route + '/' + id + (hash ? '#' + hash : '')}>
            <IconButton
                style={{
                    border: '1px solid',
                    borderRadius: '10%',
                    maxWidth: '28px',
                    maxHeight: '28px',
                    minWidth: '28px',
                    minHeight: '28px',
                    width: '28px',
                    height: '28px',
                }}
                color='primary'
            >
                <OpenInFullRoundedIcon style={{ width: '16px', height: '16px' }} />
            </IconButton>
        </Link>
    )
}

export default TableButtonOpen
